import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/internal/operators/map';


@Injectable({
  providedIn: 'root'
})
export class BranchNameService {
  constructor(public apiService: ApiService,
              private httpClient: HttpClient) {
  }

  getBranchName() {
    return this.apiService.get('/brand-name/get-list')
      .pipe(map(res => {
        return res;
      }));
  }

  activeBranchName(brandName: any, type: any) {
    return this.apiService.post(`/brand-name/activate`, {brandName, type})
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  addAccountInfor(brandName: any, username: any, password: any, type: any, cpCode: any, serviceId: any) {
    return this.apiService.post(`/brand-name/add/info`, {brandName, username, password, type, cpCode, serviceId})
      .pipe(
        map(res => {
          return res;
        })
      );
  }
}

